import Vue from "vue";
import VueRouter from "vue-router";
import Home from '@/views/home/Index.vue'
import NewHouse from '@/views/newHouse/Index.vue'
import HeadLine from '@/views/headLine/Index.vue'
import ProjectDetail from '@/views/projectDetail/Index.vue'
import headLineDetail from '@/views/headLine/detail.vue'
import vrView from '@/views/vrView/Index.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "幸福家首页",
    component: Home,
  },
  {
    path: "/newHouse",
    name: "中海新房",
    component: NewHouse,
  },
  {
    path: "/headLine",
    name: "中海头条",
    component: HeadLine,
  },
  {
    path: "/projectDetail",
    name: "项目详情",
    component: ProjectDetail,
  },
  {
    path: "/headLine/detail",
    name: "头条详情",
    component: headLineDetail,
  },
  {
    path: "/vrView",
    name: "微沙盘",
    component: vrView,
  }
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
